import AccountMutation from "./account.mutation";
import LoaderMutation from "./loader.mutation";
import QuestionMutation from "./question.mutation";
import NotificationMutation from "./notification.mutation";
import TransactionMutation from "./transaction.mutation";
import UserMutation from "./user.mutation";
import PlanMutation from "./plan.mutation";
import SettingsMutation from "./settings.mutation";
import bankAccountMutation from "./bankAccount.mutation";
import WithdrawMutation from "./withdraw.mutation";
import ToastMutation from "./toast.mutation";
import VasMutation from "./vas.mutation";
import RateMutation from "./rate.mutation";
import AppMutation from "./app.mutation";
import BusinessMutation from "./business.mutation";
import SubscriptionMutation from "./subscription.mutation";
import DisputeMutation from "./dispute.mutation";
import CardMutation from "./card.mutation";
import WalletMutation from "./wallet.mutation";

const mutations = {
    ...SettingsMutation,
    ...TransactionMutation,
    ...UserMutation,
    ...PlanMutation,
    ...LoaderMutation,
    ...NotificationMutation,
    ...AccountMutation,
    ...QuestionMutation,
    ...bankAccountMutation,
    ...WithdrawMutation,
    ...ToastMutation,
    ...VasMutation,
    ...RateMutation,
    ...AppMutation,
    ...BusinessMutation,
    ...SubscriptionMutation,
    ...DisputeMutation,
    ...CardMutation,
    ...WalletMutation
};

export default mutations;